<div
  class="aca-frmfill"
  [class.aca-admin]="!preview"
  [class.aca-frmfill--preview]="preview"
  [style.--aca-frmfill-accent]="form()?.style?.accent || null"
>
  <aca-page-header
    *ngIf="!preview"
    icon="dynamic_form"
    [title]="form()?.title || ('DMS.FORMS.TITLE' | translate)"
    [subtitle]="form()?.description || ''"
  >
    <a class="aca-frmfill__outline" routerLink="/forms"><mat-icon>arrow_back</mat-icon>{{ 'DMS.FORMS.BACK' | translate }}</a>
  </aca-page-header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />
  <aca-page-state *ngIf="failed()" state="error" [title]="'DMS.FORMS.OPEN_FAILED' | translate" [message]="failed()" />

  <!-- ── submitted ─────────────────────────────────────────────────────── -->
  <section class="aca-frmfill__done" *ngIf="done() as result" role="status">
    <span class="aca-frmfill__doneicon"><mat-icon>task_alt</mat-icon></span>
    <h2>{{ 'DMS.FORMS.DONE_TITLE' | translate }}</h2>
    <p>{{ 'DMS.FORMS.DONE_TEXT' | translate: { reference: result.reference } }}</p>
    <p class="aca-frmfill__donefile"><mat-icon>picture_as_pdf</mat-icon>{{ result.name }}</p>
    <p class="aca-frmfill__donenote aca-frmfill__donenote--good" *ngIf="result.signed">
      <mat-icon>verified</mat-icon>{{ 'DMS.FORMS.DONE_SIGNED' | translate }}
    </p>
    <ng-container *ngIf="flow() as flow">
      <p class="aca-frmfill__donenote" *ngIf="flow.state === 'starting'">
        <mat-icon>hourglass_top</mat-icon>{{ 'DMS.FORMS.FLOW_STARTING' | translate: { name: form()?.output?.workflowName } }}
      </p>
      <p class="aca-frmfill__donenote aca-frmfill__donenote--good" *ngIf="flow.state === 'started'">
        <mat-icon>account_tree</mat-icon>{{ 'DMS.FORMS.FLOW_STARTED' | translate: { name: form()?.output?.workflowName } }}
      </p>
      <p class="aca-frmfill__donenote aca-frmfill__donenote--warn" *ngIf="flow.state === 'started' && !flow.recorded">
        <mat-icon>warning</mat-icon>{{ 'DMS.FORMS.FLOW_NOT_RECORDED' | translate }}
      </p>
      <p
        class="aca-frmfill__donenote aca-frmfill__donenote--warn"
        *ngIf="flow.state === 'missing' || flow.state === 'noAssignee' || flow.state === 'failed'"
        role="alert"
      >
        <mat-icon>error</mat-icon>{{ 'DMS.FORMS.FLOW_' + (flow.state | uppercase) | translate: { name: form()?.output?.workflowName } }}
      </p>
    </ng-container>
    <div class="aca-frmfill__actions">
      <a class="aca-frmfill__primary" *ngIf="flow()?.processId as processId" [routerLink]="['/workflows/instances', processId]"
        ><mat-icon>account_tree</mat-icon>{{ 'DMS.FORMS.FOLLOW_FLOW' | translate }}</a
      >
      <button type="button" class="aca-frmfill__primary" *ngIf="flow()?.state === 'failed'" (click)="startFlow()">
        <mat-icon>refresh</mat-icon>{{ 'DMS.FORMS.FLOW_RETRY' | translate }}
      </button>
      <a
        [class.aca-frmfill__primary]="!flow()?.processId && flow()?.state !== 'failed'"
        [class.aca-frmfill__outline]="!!flow()?.processId || flow()?.state === 'failed'"
        [routerLink]="['/document', result.nodeId]"
        ><mat-icon>open_in_new</mat-icon>{{ 'DMS.FORMS.OPEN_DOCUMENT' | translate }}</a
      >
      <button type="button" class="aca-frmfill__outline" (click)="again()"><mat-icon>add</mat-icon>{{ 'DMS.FORMS.FILL_AGAIN' | translate }}</button>
      <a class="aca-frmfill__outline" routerLink="/forms">{{ 'DMS.FORMS.BACK' | translate }}</a>
    </div>
  </section>

  <!-- ── the form ──────────────────────────────────────────────────────── -->
  <form class="aca-frmfill__paper" *ngIf="form() as f" [hidden]="!!done()" (ngSubmit)="submit()" novalidate>
    <div class="aca-frmfill__head" *ngIf="preview || f.header?.organisation || f.style?.logo">
      <div class="aca-frmfill__brand">
        <img class="aca-frmfill__logo" *ngIf="f.style?.logo" [src]="f.style?.logo" alt="" />
        <div class="aca-frmfill__orgtext">
          <span class="aca-frmfill__org" *ngIf="f.header?.organisation">{{ f.header?.organisation }}</span>
          <span class="aca-frmfill__orgsub" *ngIf="f.header?.subtitle">{{ f.header?.subtitle }}</span>
        </div>
      </div>
      <h2 class="aca-frmfill__title" *ngIf="preview">{{ f.title || ('DMS.FORMS.UNTITLED' | translate) }}</h2>
      <p class="aca-frmfill__desc" *ngIf="preview && f.description">{{ f.description }}</p>
    </div>

    <ng-container *ngFor="let section of f.sections">
      <section class="aca-frmfill__section" *ngIf="sectionShown(section)">
        <h3 class="aca-frmfill__sectiontitle" *ngIf="section.title">{{ section.title }}</h3>
        <div class="aca-frmfill__grid" [class.aca-frmfill__grid--two]="section.columns === 2">
          <ng-container *ngFor="let field of section.fields">
            <div
              *ngIf="shown(field)"
              class="aca-frmfill__field"
              [class.aca-frmfill__field--wide]="wide(field, section.columns)"
              [class.aca-frmfill__field--bad]="!!problems()[field.key]"
              [ngSwitch]="field.type"
            >
              <!-- paragraph: words only -->
              <p *ngSwitchCase="'paragraph'" class="aca-frmfill__para">{{ field.text || field.label }}</p>

              <!-- worked out from other fields: shown, never typed -->
              <ng-container *ngSwitchCase="'calc'">
                <span class="aca-frmfill__label" [id]="'ff-' + field.key + '-label'">{{ field.label }}</span>
                <output class="aca-frmfill__calc" [attr.aria-labelledby]="'ff-' + field.key + '-label'" aria-live="polite">
                  <mat-icon aria-hidden="true">calculate</mat-icon>
                  <ng-container *ngIf="calcValue(field) !== null; else noAnswer">
                    {{ calcValue(field) | number: (printedType(field) === 'money' ? '1.2-2' : '1.0-2')
                    }}<ng-container *ngIf="printedType(field) === 'money'"> {{ 'DMS.FORMS.BAHT' | translate }}</ng-container>
                  </ng-container>
                  <ng-template #noAnswer><span class="aca-frmfill__calcnone">—</span></ng-template>
                </output>
                <span class="aca-frmfill__words" *ngIf="printedType(field) === 'money' && calcValue(field) !== null"
                  >({{ amountWords(calcValue(field)) }})</span
                >
              </ng-container>

              <!-- one tick box: the label is the statement -->
              <ng-container *ngSwitchCase="'checkbox'">
                <label class="aca-frmfill__tick" [for]="'ff-' + field.key">
                  <input type="checkbox" [id]="'ff-' + field.key" [name]="field.key" [(ngModel)]="values[field.key]" (ngModelChange)="check(field)" />
                  <span>{{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span></span>
                </label>
              </ng-container>

              <!-- choose one / choose any -->
              <fieldset *ngSwitchCase="'radio'" class="aca-frmfill__choices">
                <legend class="aca-frmfill__label">
                  {{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span>
                </legend>
                <label class="aca-frmfill__choice" *ngFor="let option of field.options; let i = index" [for]="'ff-' + field.key + '-' + i">
                  <input
                    type="radio"
                    [id]="'ff-' + field.key + '-' + i"
                    [name]="field.key"
                    [value]="option"
                    [(ngModel)]="values[field.key]"
                    (ngModelChange)="check(field)"
                  />
                  {{ option }}
                </label>
              </fieldset>
              <fieldset *ngSwitchCase="'checkboxes'" class="aca-frmfill__choices">
                <legend class="aca-frmfill__label">
                  {{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span>
                </legend>
                <label class="aca-frmfill__choice" *ngFor="let option of field.options; let i = index" [for]="'ff-' + field.key + '-' + i">
                  <input
                    type="checkbox"
                    [id]="'ff-' + field.key + '-' + i"
                    [name]="field.key + '-' + i"
                    [checked]="isChecked(field, option)"
                    (change)="toggle(field, option, $any($event.target).checked)"
                  />
                  {{ option }}
                </label>
              </fieldset>

              <!-- a table of rows -->
              <ng-container *ngSwitchCase="'table'">
                <span class="aca-frmfill__label" [id]="'ff-' + field.key + '-label'">
                  {{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span>
                </span>
                <div class="aca-frmfill__tablewrap">
                  <table class="aca-frmfill__table" [attr.aria-labelledby]="'ff-' + field.key + '-label'">
                    <thead>
                      <tr>
                        <th class="aca-frmfill__no">#</th>
                        <th *ngFor="let column of field.columns" [class.aca-frmfill__num]="numeric(column)">{{ column.label }}</th>
                        <th class="aca-frmfill__no">
                          <span class="aca-sr-only">{{ 'DMS.FORMS.REMOVE_ROW' | translate }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of rows(field); let r = index">
                        <td class="aca-frmfill__no">{{ r + 1 }}</td>
                        <td *ngFor="let column of field.columns" [ngSwitch]="column.type">
                          <output *ngSwitchCase="'calc'" class="aca-frmfill__calccell" [attr.aria-label]="column.label + ' ' + (r + 1)">{{
                            calcCell(field, r, column) === null
                              ? ''
                              : (calcCell(field, r, column) | number: (printedType(column) === 'money' ? '1.2-2' : '1.0-2'))
                          }}</output>
                          <aca-date-input
                            *ngSwitchCase="'date'"
                            class="aca-frmfill__cell"
                            [ariaLabel]="column.label + ' ' + (r + 1)"
                            [name]="field.key + '-' + r + '-' + column.key"
                            [(ngModel)]="row[column.key]"
                            (ngModelChange)="changed(field)"
                          />
                          <ng-container *ngSwitchDefault>
                            <input
                              class="aca-frmfill__cell"
                              [class.aca-frmfill__num]="numeric(column)"
                              type="text"
                              [attr.inputmode]="numeric(column) ? 'decimal' : null"
                              [attr.aria-label]="column.label + ' ' + (r + 1)"
                              [name]="field.key + '-' + r + '-' + column.key"
                              [(ngModel)]="row[column.key]"
                              (ngModelChange)="changed(field)"
                              (blur)="check(field)"
                            />
                          </ng-container>
                        </td>
                        <td class="aca-frmfill__no">
                          <button
                            type="button"
                            class="aca-frmfill__iconbtn"
                            (click)="removeRow(field, r)"
                            [attr.aria-label]="('DMS.FORMS.REMOVE_ROW' | translate) + ' ' + (r + 1)"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="hasMoney(field)">
                      <tr>
                        <td></td>
                        <td *ngFor="let column of field.columns; let c = index" [class.aca-frmfill__num]="numeric(column)">
                          <ng-container *ngIf="totalled(field, column); else totalLabel">{{ total(field, column) | number: '1.2-2' }}</ng-container>
                          <ng-template #totalLabel>{{ c === 0 ? ('DMS.FORMS.TOTAL' | translate) : '' }}</ng-template>
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <button type="button" class="aca-frmfill__addrow" (click)="addRow(field)" [disabled]="rows(field).length >= rowLimit(field)">
                  <mat-icon>add</mat-icon>{{ 'DMS.FORMS.ADD_ROW' | translate }}
                </button>
                <span class="aca-frmfill__help" *ngIf="form()?.paper && rowLimit(field) < 200">{{
                  'DMS.FORMS.ROWS_ON_PAPER' | translate: { rows: rowLimit(field) }
                }}</span>
              </ng-container>

              <!-- drawn or typed on the page, printed as a picture -->
              <ng-container *ngSwitchCase="'signature'">
                <span class="aca-frmfill__label" [id]="'ff-' + field.key + '-label'">
                  {{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span>
                </span>
                <app-form-signature
                  [inputId]="'ff-' + field.key"
                  [labelId]="'ff-' + field.key + '-label'"
                  [invalid]="!!problems()[field.key]"
                  [value]="$any(values[field.key]) || ''"
                  (valueChange)="values[field.key] = $event; changed(field)"
                />
                <span class="aca-frmfill__help" *ngIf="field.inFooter && f.footer?.signatures?.length">{{
                  'DMS.FORMS.SIGNATURE_GOES_TO' | translate: { box: f.footer!.signatures[0] }
                }}</span>
              </ng-container>

              <!-- the house and street typed, the area picked from the list -->
              <ng-container *ngSwitchCase="'address'">
                <span class="aca-frmfill__label" [id]="'ff-' + field.key + '-label'">
                  {{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span>
                </span>
                <app-form-address
                  [inputId]="'ff-' + field.key"
                  [labelId]="'ff-' + field.key + '-label'"
                  [invalid]="!!problems()[field.key]"
                  [value]="$any(values[field.key])"
                  (valueChange)="values[field.key] = $event; changed(field)"
                  (touched)="check(field)"
                />
              </ng-container>

              <!-- everything else: a label and one box -->
              <ng-container *ngSwitchDefault>
                <label class="aca-frmfill__label" [for]="'ff-' + field.key">
                  {{ field.label }}<span class="aca-frmfill__req" *ngIf="field.required" aria-hidden="true"> *</span>
                </label>
                <textarea
                  *ngIf="field.type === 'textarea'"
                  class="aca-frmfill__input aca-frmfill__input--long"
                  [id]="'ff-' + field.key"
                  [name]="field.key"
                  rows="4"
                  [placeholder]="field.placeholder || ''"
                  [attr.aria-label]="field.placeholder || ''"
                  [attr.aria-required]="field.required || null"
                  [attr.aria-invalid]="!!problems()[field.key] || null"
                  [(ngModel)]="values[field.key]"
                  (ngModelChange)="changed(field)"
                  (blur)="check(field)"
                ></textarea>
                <select
                  *ngIf="field.type === 'select'"
                  class="aca-frmfill__input"
                  [id]="'ff-' + field.key"
                  [name]="field.key"
                  [attr.aria-required]="field.required || null"
                  [attr.aria-invalid]="!!problems()[field.key] || null"
                  [(ngModel)]="values[field.key]"
                  (ngModelChange)="check(field)"
                >
                  <option value="">{{ 'DMS.FORMS.CHOOSE' | translate }}</option>
                  <option *ngFor="let option of field.options" [value]="option">{{ option }}</option>
                </select>
                <aca-date-input
                  *ngIf="field.type === 'date'"
                  class="aca-frmfill__input"
                  [inputId]="'ff-' + field.key"
                  [name]="field.key"
                  [(ngModel)]="values[field.key]"
                  (ngModelChange)="check(field)"
                />
                <input
                  *ngIf="field.type !== 'textarea' && field.type !== 'select' && field.type !== 'date'"
                  class="aca-frmfill__input"
                  [class.aca-frmfill__num]="field.type === 'money' || field.type === 'number'"
                  [id]="'ff-' + field.key"
                  [name]="field.key"
                  [type]="inputType(field)"
                  [attr.inputmode]="inputMode(field)"
                  [attr.maxlength]="field.type === 'thaiId' ? 17 : null"
                  [placeholder]="field.placeholder || (field.type === 'thaiId' ? 'x-xxxx-xxxxx-xx-x' : '')"
                  [attr.aria-label]="field.placeholder || (field.type === 'thaiId' ? 'x-xxxx-xxxxx-xx-x' : '')"
                  [attr.aria-required]="field.required || null"
                  [attr.aria-invalid]="!!problems()[field.key] || null"
                  autocomplete="off"
                  [(ngModel)]="values[field.key]"
                  (ngModelChange)="changed(field)"
                  (blur)="check(field)"
                />
                <span class="aca-frmfill__words" *ngIf="field.type === 'money' && amountWords(values[field.key]) as words">({{ words }})</span>
              </ng-container>

              <span class="aca-frmfill__help" *ngIf="field.help && field.type !== 'paragraph'">{{ field.help }}</span>
              <span class="aca-frmfill__problem" *ngIf="problems()[field.key]" role="alert"
                ><mat-icon>error_outline</mat-icon>{{ problemText(field) }}</span
              >
            </div>
          </ng-container>
        </div>
      </section>
    </ng-container>

    <div class="aca-frmfill__signs" *ngIf="f.footer?.signatures?.length">
      <mat-icon>draw</mat-icon>{{ 'DMS.FORMS.SIGNATURES_NOTE' | translate: { boxes: f.footer!.signatures.join(', ') } }}
    </div>

    <p class="aca-frmfill__error" *ngIf="error()" role="alert"><mat-icon>error_outline</mat-icon>{{ error() }}</p>

    <div class="aca-frmfill__footer">
      <span class="aca-frmfill__where" *ngIf="!preview">
        <mat-icon>folder_open</mat-icon>{{ 'DMS.FORMS.SAVED_TO' | translate: { folder: f.output?.folderName || ('DMS.FORMS.MY_FILES' | translate) } }}
      </span>
      <span class="aca-frmfill__where" *ngIf="preview"><mat-icon>visibility</mat-icon>{{ 'DMS.FORMS.PREVIEW_NOTE' | translate }}</span>
      <button type="button" class="aca-frmfill__outline" (click)="showPdf()" [disabled]="!!working()">
        <mat-icon>picture_as_pdf</mat-icon>{{ (working() === 'pdf' ? 'DMS.FORMS.PRINTING' : 'DMS.FORMS.SHOW_PDF') | translate }}
      </button>
      <button type="submit" class="aca-frmfill__primary" *ngIf="!preview" [disabled]="!!working()">
        <mat-icon>send</mat-icon>{{ (working() === 'submit' ? 'DMS.FORMS.SUBMITTING' : 'DMS.FORMS.SUBMIT') | translate }}
      </button>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="working()" />
  </form>
</div>
